import React, { Component } from 'react';
import { Select } from '@material-ui/core';

export default class StatefulSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value || ''
        }
    }

    onChange(event) {
        let value = event.target.value;

        this.setState({value});
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    render() {
        return (
            <Select
                fullWidth
                value={this.state.value}
                onChange={this.onChange.bind(this)}>
                {this.props.children}
            </Select>
        ) 
    }
}


// WEBPACK FOOTER //
// ./src/components/StatefulSelect/StatefulSelect.jsx